import React, { useEffect, useState } from "react";
import { getMyProfile } from "../../api/register";
import { person } from "../../assets/img";

const Header = () => {
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    getMyProfile()
      .then((res) => {
        console.log("EMPLOYEE DATA:", res.data.employee);
        setEmployee(res.data.employee);
      })
      .catch((err) => {
        console.error("Failed to fetch profile:", err);
      });
  }, []);

  if (!employee) return null;

  console.log("EMPLOYEE IMAGE URL:", employee.profileImage); // ✅ check URL

  return (
    <div className="employee-header">
      <div className="employee-info">
        <h1>
          Name : <span>{employee.firstName} {employee.lastName}</span>
        </h1>
        <h3>
          Employee ID : <span>{employee.employeeId}</span>
        </h3>
      </div>

      <div className="employee-avatar">
        <img
          src={employee.profileImage || person}
          alt="Employee"

          // ✅ SUCCESS
          onLoad={() => {
            console.log("✅ EMPLOYEE IMAGE LOADED");
          }}

          // ❌ FAIL
          onError={(e) => {
            console.log("❌ EMPLOYEE IMAGE FAILED");
            console.log("BROKEN URL:", employee.profileImage);

            e.target.src = person;
          }}
        />
      </div>
    </div>
  );
};

export default Header;